// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"c74b1033","484":"1ab3ac05","551":"cdc243e9","869":"8e9048bf","974":"2ea8dc15"}[chunkId] + ".chunk.js";
};